import {LogInformationRow} from '@components/seguranca/LogInformation.tsx';
import {GetRecursoLogs} from '@localization/siteMap/endpoints/_RecursosEndpoints.ts';
import {IPagination} from '@localization/siteMap/siteMapInterfaces.ts';
import {DefaultPageProps} from '@models/DefaultProps.ts';
import {RecursoLogFilterDto} from '@models/recurso/RecursoLogFilterDto.tsx';
import {ILog} from '@models/seguranca/ILog.ts';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import {DefaultPagination} from '@shared/specialComponents/DefaultPagination.tsx';
import React, {useEffect, useState} from 'react';
import {useApi} from "@contexts/hooks/api/useApi.ts";

export interface LogsPageProps extends DefaultPageProps {
	filters?: RecursoLogFilterDto;
}

export const RecursoLogsPage: React.FC<LogsPageProps> = (props) => {
	const [logs, setLogs] = React.useState<ILog[]>([]);
	const [filters, _setFilters] = React.useState<RecursoLogFilterDto>(props.filters || {});
	const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
	const [loading, setLoading] = useState<boolean>(false);
	const {Get} = useApi();
	
	useEffect(() => {
		if (pagination.page <= 0) {
			setPagination({...pagination, page: 1});
			return;
		}
		
		setLoading(true);
		Get(GetRecursoLogs(filters, pagination)).then((x) => {
			if (x.status === 'Success') {
				setLogs(x.items);
                setPagination(prev => ({...prev, ...x.pagination}));
			}
		}).finally(() => setLoading(false));
	}, [pagination.page]);
	
	return (
		<DefaultContainer hideHeader={props.hideHeader} size={'max'} titulo={'Logs '} component={'div'} spacing={0}
		                  permissaoNecessaria={['VisualizarLogs']}>
			<DefaultPagination pagination={pagination} setPagination={setPagination} posicao={'top'} loading={loading}/>
			
			<TableContainer>
				<Table size={'small'} stickyHeader>
					<TableHead>
						<TableRow>
							<TableCell>Usuario</TableCell>
							<TableCell>Detalhes</TableCell>
							<TableCell>Data e Hora</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
                        {logs.map((x) => {
                            return <LogInformationRow key={x.id} value={x}/>;
						})}
					</TableBody>
				</Table>
			</TableContainer>
			
			<DefaultPagination pagination={pagination} setPagination={setPagination} posicao={'bottom'}
			                   loading={loading}/>
		
		</DefaultContainer>);
};